module.exports = __webpack_public_path__ + "assets/img/home-quotes.0c1f62a4.png";